import React from 'react';
import './styles.scss';
import { Spinner } from 'react-bootstrap';
import Button from '../../../components/molecules/buttons';
import Forms from '../../../components/molecules/forms';
import useClients from './hooks';
import Card from '../../../components/molecules/cards';
import LandingHeader from '../../../components/layout/header/landing';

function Clients(): React.ReactElement {
  const {
    navigateToAddClient, clientList, loadingClientList,
    searchValue, setSearchValue,
  } = useClients();

  const renderClientList = () => {
    if (loadingClientList) {
      return (
        <div className="flexible-center">
          <Spinner className="fz-14" animation="border" />
        </div>
      );
    }
    if (clientList && clientList.length) {
      return (
        <div className="row">
          {clientList.map((client) => (
            <div key={client.id} className="col-xl-3 col-lg-4 col-md-6 col-sm-12 mb-2">
              <Card.Poin
                title={client.title}
                desc={client.address}
                id={client.id.toString()}
              />
            </div>
          ))}
        </div>
      );
    }
    return <div className="text-center">Data Not Found</div>;
  };

  return (
    <div className="py-4">
      <LandingHeader title="Clients" />
      <div className="px-4 px-xl-5">
        <div className="d-flex justify-content-between mb-5" style={{ height: '42px' }}>
          <div style={{ maxWidth: '500px' }} className="h-100 w-100 me-2">
            <Forms.Search
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              placeholder="Search something"
            />
          </div>
          <div style={{ width: '200px' }}>
            <Button.Default
              id="addClients"
              type="button"
              label="Add Client"
              onClick={navigateToAddClient}
            />
          </div>
        </div>
        <div className="w-100">
          {renderClientList()}
        </div>
      </div>
    </div>
  );
}

export default Clients;
